module.exports = __webpack_public_path__ + "img/photo-0017.ce9d4d19.jpg";